import * as Yup from "yup";

export const loginFormValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required("O campo e-mail é obrigatório")
    .email("Por favor, insira um e-mail válido")
    .trim(),
});
